var AdaptiveImage = require("../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "src/assets/web/images/tex_log_white.png",
    width: 151,
    height: 35
});